import preloader from "preloader-js";

const preloaderJs = function () {
  $(document).ready(function () {
    preloader.hide();
  });
}

export default preloaderJs;